import { app } from '@tivio/core-js'
import { useEffect, useState } from 'react'

import { useTaggedVideos } from './useTaggedVideos'

import type { SubscribeToTaggedVideosOptions, UseEpisodesQueryOptions, UseEpisodesResult } from '@tivio/types'

/**
 * Returns episodes of concrete season of series defined by seriesTagId.
 *
 * @param seriesTagId tagId of tag of type 'Series'
 * @param seasonNumber number of series season
 * @param limit pagination limit
 * @deprecated use useSeriesEpisodes instead
 */
export const useEpisodes = (
    seriesTagId: string | null | undefined,
    seasonNumber: number | null,
    options: UseEpisodesQueryOptions,
    organizationPath?: string,
): UseEpisodesResult => {
    const [queryOptions, setQueryOptions] = useState<SubscribeToTaggedVideosOptions>()
    const { limit, fetchTags = true, orderBy } = options

    useEffect(() => {
        if (seasonNumber !== null && seriesTagId) {
            setQueryOptions(constructQueryOptions(seasonNumber, limit, fetchTags, orderBy))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- orderBy is an array of objects so it needs to be stringified to not trigger a infinite loop
    }, [seasonNumber, limit, fetchTags, seriesTagId, JSON.stringify(orderBy)])

    const { pagination } = useTaggedVideos(seriesTagId ? [seriesTagId] : null, queryOptions, organizationPath)

    return {
        episodes: pagination?.items ?? [],
        fetchMoreEpisodes: pagination?.fetchMore,
        episodesLoading: pagination?.loading ?? true,
        hasMoreEpisodes: pagination?.hasNextPage ?? false,
    }
}

/**
 * Construct query filter based on provided seasonNumber and limit.
 *
 * @param seasonNumber number of series season
 * @param limit pagination limit
 */
const constructQueryOptions = (
    seasonNumber: number,
    limit: number,
    fetchTags: boolean,
    orderBy?: UseEpisodesQueryOptions['orderBy'],
): SubscribeToTaggedVideosOptions => {
    return {
        limit,
        fetchTags,
        where: [
            { field: 'seasonNumber', operator: '==', value: seasonNumber },
        ],
        orderBy: orderBy ?? [
            { field: 'episodeNumber', directionStr: app.organization?.seriesConfiguration?.episodes?.orderByDirection ?? 'asc' },
        ],
    }
}